<template>
  <div class="footer">
    <footer-scroll></footer-scroll>
    <!-- <span id="star-five" class="scroll"></span> -->
    <el-divider></el-divider>
    <span @click="NewsDrawer = true" class="link">Update info</span>
    <el-divider direction="vertical"></el-divider>
    <!-- <span @click="StatisDrawer = true" class="link"> -->
    <span class="link">
<a href="https://mapmyvisitors.com/web/1bxg6" title="Visit tracker" style="text-decoration: none;">
  <img
    src="https://mapmyvisitors.com/map.png?d=yHJFKVYSnvqI6Ip_iVSdMGcTFHXvtJSCluvB6nbwxjk&cl=ffffff"
    alt="Visit tracker"
    style="width: 120px; height: auto; border-radius: 8px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);"
  />
</a>
    </span>
    <el-divider direction="vertical"></el-divider>
    <span @click="contactDrawer = true" class="link">Contact us</span>
    <br />
    <br />
    <span class="copyright">
      <slot name="copyright">
        Copyright &copy; 2023 &ndash; 2026 Zhejiang University, <a href="https://bis.zju.edu.cn/" style="text-decoration: none">Ming Chen Lab</a> 
        and Nanjing University, <a href="https://compbio.nju.edu.cn" style="text-decoration: none" target="_blank">Dijun Chen Lab</a>. 
        All right reserved. Designed by 
        <span @click="dialogVisible = true" class="link" style="color:#007bff">ZJU-NJU Team</span>
      </slot>
    </span>
  <!-- 弹窗 -->
<el-dialog
  :visible.sync="dialogVisible"
  width="1000px"
  :close-on-click-modal="true"
  :show-close="false"
>
  <!-- 使用 slot 自定义 title -->
  <template #title>
    <div style="font-size: 24px; font-weight: bold; color: #4CAF50; display: flex; align-items: center; justify-content: center;">
      <span class="title-animation" style="font-size: 18px; margin-right: 20px;">🌟</span>
      ZJU-NJU Team
      <span class="title-animation" style="font-size: 18px; margin-left: 20px;">🌟</span>
    </div>
  </template>

  <div style="line-height: 1.8;">
    <table style="width: 100%; border-collapse: collapse;">
      <tbody>
        <!-- 第一组成员 -->
        <tr>
          <td style="width: 40%; text-align: right; padding: 8px; vertical-align: middle;">
            <div style="display: flex; align-items: center; justify-content: flex-end; gap: 10px;">
              <el-avatar :src="require('@/assets/img/boy1.svg')" size="small" style="background-color: transparent"/>
              <strong>Haoyu Chao</strong>
              <el-avatar :src="require('@/assets/img/boy2.svg')" size="small" style="background-color: transparent"/>
              <strong>Zhonghao Ruan</strong>
            </div>
          </td>
          <td style="text-align: left; padding: 8px;">
            Frontend & Backend refinement, optimization, and maintenance
          </td>
        </tr>

        <!-- 第三组成员 -->
        <tr>
          <td style="text-align: right; padding: 8px; vertical-align: middle;">
            <div style="display: flex; align-items: center; justify-content: flex-end; gap: 10px;">
              <el-avatar :src="require('@/assets/img/boy4.svg')" size="small" style="background-color: transparent"/>
              <strong>Sida Li</strong>
              <el-avatar :src="require('@/assets/img/boy5.svg')" size="small" style="background-color: transparent"/>
              <strong>Shilong Zhang</strong>
            </div>
          </td>
          <td style="text-align: left; padding: 8px;">
            Deployment and server maintenance on ZJU server
          </td>
        </tr>

        <!-- 第二组成员 -->
        <tr>
          <td style="text-align: right; padding: 8px; vertical-align: middle;">
            <div style="display: flex; align-items: center; justify-content: flex-end; gap: 10px;">
              <el-avatar :src="require('@/assets/img/boy1.svg')" size="small" style="background-color: transparent" />
              <strong>Haoyu Chao</strong>
              <el-avatar :src="require('@/assets/img/girl.svg')" size="small" style="background-color: transparent" />
              <strong>Zhuojin Li</strong>
            </div>
          </td>
          <td style="text-align: left; padding: 8px;">
            Literature tracking and metadata collection 
          </td>
        </tr>
      </tbody>
    </table>

    <hr style="margin: 20px 0;" />

    <p style="margin-top: 10px;">
      <strong>Acknowledgement:</strong>
      Special thanks to <el-avatar :src="require('@/assets/img/boy3.svg')" size="small" style="vertical-align: middle; margin: 0 6px 0 10px;background-color: transparent" />
      <strong>Xinkai Zhou</strong> for providing the initial frontend & backend structure,
      originated from <a href="https://biobigdata.nju.edu.cn/pgdatabase/" target="_blank" style="text-decoration: none">PGCP</a>.
    </p>
  </div>
</el-dialog>




    <!-- News Drawer -->
    <el-drawer
      title="Update history"
      size="400px"
      :visible.sync="NewsDrawer"
      :direction="NewsDirection"
      style="text-align: left"
    >
      <slot name="Update">
      <el-timeline>

          <el-timeline-item timestamp="2025/12/23">
            <b>Invitation Received</b>
            <br />
            Invitation to submit a manuscript from Executive Editor
          </el-timeline-item>

          <el-timeline-item timestamp="2025/11/20">
            <b>Proposal Submission</b>
            <br />
            Proposal submitted to <i>Nucleic Acids Res.</i>
          </el-timeline-item>

          <el-timeline-item timestamp="2025/10/01">
            <b>Project Renamed</b>
            <br />
            Renamed from PlanT2T to <span style="color: #2ca25f">T2T-Hub</span>
          </el-timeline-item>

          <el-timeline-item timestamp="2025/9/10">
            <b>Animal Analysis Module Completed</b>
          </el-timeline-item>

          <el-timeline-item timestamp="2025/7/10">
            <b>Data Update</b>
            <br />
            Add <span style="color: #2ca25f">39</span> animal genomes
          </el-timeline-item>

          <el-timeline-item timestamp="2025/4/10">
            <b>Data Update</b>
            <br />
            Add <span style="color: #2ca25f">77</span> plant genomes
          </el-timeline-item>

          <el-timeline-item timestamp="2025/02/23">
            <b>Proposal Review Feedback</b>
            <br />
            Invited to improve and resubmit in the next year
          </el-timeline-item>

          <el-timeline-item timestamp="2025/01/10">
            <b
              >Open All Analysis Codes on
              <a
                href="https://github.com/BioOmics/T2T-Hub"
                target="_blank"
                rel="noopener noreferrer"
                >GitHub</a
              ></b
            >
          </el-timeline-item>

          <!-- <el-timeline-item timestamp="2024/12/20">
            <b>
              Submit proposal to
              <br />
              <span style="color: #2ca25f">Nucleic Acids Research</span></b
            >
          </el-timeline-item> -->

          <el-timeline-item timestamp="2025/01/10">
            <b>Plant Analysis Module Completed</b>
          </el-timeline-item>

          <el-timeline-item timestamp="2025/01/01">
            <b>PlanT2T <span style="color: #ff4949">v1.0</span> released</b>
          </el-timeline-item>

          <el-timeline-item timestamp="2024/12/20">
            <b>Proposal Submission</b>
            <br />
            Proposal submitted to <i>Nucleic Acids Res.</i>
          </el-timeline-item>

          <el-timeline-item timestamp="2024/9/25">
            <b>Data Update</b>
            <br />
            Add <span style="color: #2ca25f">36</span> plant genomes
          </el-timeline-item>

          <el-timeline-item timestamp="2024/8/10">
            <b>Tools </b>
            <br />
            Add <span style="color: #9a60b4"><b>14</b></span> tools
          </el-timeline-item>

          <el-timeline-item timestamp="2024/5/24">
            <b>Data Update</b>
            <br />
            Add <span style="color: #2ca25f">73</span> plant genomes
          </el-timeline-item>

          <el-timeline-item timestamp="2023/4/13">
            <b>Data Update</b>
            <br />
            Add <span style="color: #2ca25f">30</span> plant genomes
          </el-timeline-item>
          <el-timeline-item timestamp="2023/4/8">
            <b>Project <span style="color: #2ca25f">T2T-Hub</span> started</b>
          </el-timeline-item>
        </el-timeline>
      </slot>
    </el-drawer>
    <!-- Statistic Drawer -->
    <!-- <el-drawer
      title="Worldwide Visitor Activity"
      size="50%"
      :visible.sync="StatisDrawer"
      :direction="StatisDirection"
    >
      <slot name="statistic">
        <div id="map-container" ref="mapContainer" class="container"></div>
        <br />
        <div id="bar-container" ref="barContainer" class="container"></div>
        <div>
          <a href="https://mapmyvisitors.com/web/1bxg6" title="Visit tracker">
            <img
              src="https://mapmyvisitors.com/map.png?d=yHJFKVYSnvqI6Ip_iVSdMGcTFHXvtJSCluvB6nbwxjk&cl=ffffff"
            />
          </a>
        </div>
      </slot>
    </el-drawer> -->
    <!-- Contact Drawer -->
    <el-drawer
      title="Contact us"
      size="35%"
      :visible.sync="contactDrawer"
      :direction="contactDirection"
    >
<p class="info">
  <i class="el-icon-user"></i>
  Developer:
  <a href="mailto:haoyuchao@zju.edu.cn?subject=T2T-Hub Support">Haoyu Chao</a>
  &
  <a href="mailto:ruanzhonghao99@gmail.com?subject=T2T-Hub Support">Zhonghao Ruan</a>
  <br />
  <i class="el-icon-message"></i>
  E-mail:
  <a href="mailto:haoyuchao@zju.edu.cn?subject=T2T-Hub Support">haoyuchao@zju.edu.cn</a>
  &
  <a href="mailto:ruanzhonghao99@gmail.com?subject=T2T-Hub Support">ruanzhonghao99@gmail.com</a>
</p>

<p class="info">
  <i class="el-icon-user"></i>
  Corresponding author:
  <a href="mailto:mchen@zju.edu.cn?subject=T2T-Hub Correspondence">Ming Chen</a>
  <br />
  <i class="el-icon-message"></i>
  E-mail:
  <a href="mailto:mchen@zju.edu.cn?subject=T2T-Hub Correspondence">mchen@zju.edu.cn</a>
</p>

      <p class="info">
        <i class="bi-mailbox"></i>
        <slot name="post"> Post code: 310058 </slot>
        <br />
      </p>
      <p class="info">
        <i class="el-icon-location-outline"></i>
        <slot name="location">
          236 Room, Department of Bioinformatics, College of Life Sciences,
          Zhejiang University, Zijingang Campus, Hangzhou, P.R.China
        </slot>
      </p>

      <div class="card-body">
        <slot name="map">
          <iframe
            width="100%"
            height="500"
            frameborder="0"
            src="https://cn.bing.com/maps/embed?h=480&amp;w=725&amp;cp=30.29598745731586~120.09103195251078&amp;lvl=17&amp;typ=d&amp;sty=r&amp;src=SHELL&amp;FORM=MBEDV8"
          ></iframe>
          <div style="white-space: nowrap; text-align: center; padding: 6px 0">
            <a
              id="largeMapLink"
              target="_blank"
              href="https://cn.bing.com/maps?cp=30.303172~120.09248&amp;sty=r&amp;lvl=14&amp;FORM=MBEDLD"
              >View Larger Map</a
            >
            &nbsp; | &nbsp;
            <a
              id="dirMapLink"
              target="_blank"
              href="https://cn.bing.com/maps/directions?cp=30.303172~120.09248&amp;sty=r&amp;lvl=14&amp;rtp=~pos.30.303172~120.09248____&amp;FORM=MBEDLD"
              >Get Directions</a
            >
          </div>
        </slot>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import FooterScroll from "./FooterScroll.vue";

export default {
  components: { FooterScroll },
  data() {
    return {
      contactDrawer: false,
      contactDirection: "ltr",
      NewsDrawer: false,
      NewsDirection: "rtl",
      StatisDrawer: false,
      StatisDirection: "ltr",
      dialogVisible: false,
    };
  },
  computed: {
    statisWidth() {
      // 计算当前视口宽度的一半
      return document.documentElement.clientWidth * 0.5;
    },
  },
  watch: {
    StatisDrawer(val) {
      if (val) {
        // 当StatisDrawer显示时插入RevolverMaps脚本
        this.$nextTick(() => {
          // this.loadRevolverMapsScript();
          this.loadBarChartScript();
        });
      }
    },
  },
  methods: {
    // loadRevolverMapsScript() {
    //   const mapContainer = this.$refs.mapContainer;

    //   if (!mapContainer) {
    //     console.error("Map container not found");
    //     return;
    //   }

    //   // 清理旧的地图容器内容
    //   while (mapContainer.firstChild) {
    //     mapContainer.removeChild(mapContainer.firstChild);
    //   }

    //   // 移除可能存在的旧脚本
    //   const existingMapScript = document.getElementById(
    //     "revolvermaps-map-script"
    //   );
    //   if (existingMapScript) {
    //     existingMapScript.remove();
    //   }

    //   // 创建并加载RevolverMaps地图脚本
    //   const mapScript = document.createElement("script");
    //   mapScript.id = "revolvermaps-map-script";
    //   mapScript.type = "text/javascript";
    //   mapScript.src =
    //     "//rf.revolvermaps.com/0/0/7.js?i=5sg8iatbeq5&amp;m=0&amp;c=ff0000&amp;cr1=ffffff&amp;sx=0";
    //   mapScript.async = true;
    //   mapScript.onload = () => {
    //     console.log("RevolverMaps map script loaded");
    //   };
    //   mapScript.onerror = () => {
    //     console.error("Error loading RevolverMaps map script");
    //   };
    //   mapContainer.appendChild(mapScript);
    // },
    loadBarChartScript() {
      const barContainer = this.$refs.barContainer;

      if (!barContainer) {
        console.error("Bar container not found");
        return;
      }

      // 清理旧的条形图容器内容
      while (barContainer.firstChild) {
        barContainer.removeChild(barContainer.firstChild);
      }

      // 移除可能存在的旧脚本
      const existingBarScript = document.getElementById(
        "revolvermaps-bar-script"
      );
      if (existingBarScript) {
        existingBarScript.remove();
      }

      // 创建并加载RevolverMaps条形图脚本
      const barScript = document.createElement("script");
      barScript.id = "revolvermaps-bar-script";
      barScript.type = "text/javascript";
      barScript.src =
        "//rf.revolvermaps.com/0/0/0.js?i=5ifcxudxqbs&amp;d=2&amp;p=0&amp;b=8&amp;w=293&amp;g=3&amp;f=arial&amp;fs=14&amp;r=0&amp;c0=409eff&amp;c1=2ca25f&amp;c2=000000&amp;ic0=0&amp;ic1=0";
      barScript.async = true;
      barScript.onload = () => {
        console.log("RevolverMaps bar chart script loaded");
      };
      barScript.onerror = () => {
        console.error("Error loading RevolverMaps bar chart script");
      };
      barContainer.appendChild(barScript);
    },
  },
};
</script>


<style>
.footer {
  height: 120px;
  text-align: center;
  font-size: 16px;
  padding: 0px 100px;
  position: relative;
}
.footer .link {
  cursor: pointer;
  font-weight: 600;
}
.copyright {
  font-size: 12px;
}
.footer .info {
  font-size: 14px;
  color: #72767b;
  line-height: 25px;
}
.footer a {
  text-decoration: none;
}
.footer .card-body {
  width: 90%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin: auto;
  padding: 10px;
}
.footer .card-body a {
  text-decoration: none;
}
.el-drawer {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

#map-container,
#bar-container {
  border-radius: 8px; /* Adjust the radius as needed */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Adjust the shadow as needed */
  padding: 10px; /* Optional: adds padding inside the container */
  background-color: #fff; /* Optional: sets a background color */
}

#map-container {
  flex: 1;
  height: flex-grow;
  position: relative;
}

#bar-container {
  height: 100px;
  position: relative;
}

  .title-animation {
    animation: bounce 2s infinite;
  }

  @keyframes bounce {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
    }
  }
</style>